type StatsCardProps = {
    title: string;
    value: number | string;
    icon: React.ReactNode;
    iconBg?: string;
    trend?: { value: number; label: string; up: boolean };
};

const StatsCard = ({ title, value, icon, iconBg = '#2563eb', trend }: StatsCardProps) => (
    <div className="bg-bg-card border border-border rounded-xl p-5 shadow-card">
        <div className="flex items-start justify-between mb-3">
            <p className="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-0!">{title}</p>
            <div className="w-10 h-10 rounded-full flex items-center justify-center shrink-0" style={{ backgroundColor: iconBg }}>
                {icon}
            </div>
        </div>
        <p className="text-3xl font-bold mb-0!">
            {typeof value === 'number' ? value.toLocaleString() : value}
        </p>
        {trend && (
            <p className={`text-sm mt-2 mb-0! ${trend.up ? 'text-green-500' : 'text-red-500'}`}>
                {trend.up ? '↑' : '↓'} {trend.value}% {trend.label}
            </p>
        )}
    </div>
);

export default StatsCard;
